import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '../../abstract-components/base.component';

@Component({
  selector: 'empty-card',
  standalone: false,
  templateUrl: './empty-card.component.html',
  styleUrls: ['./empty-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyCardComponent extends BaseComponent {
  title = input<string | undefined>(undefined);
  subTitle = input<string | undefined>(undefined);
  iconSize = input<number>(200);
}
